import styled from 'styled-components'

export const SwatchImg = styled.img`
  display: block;
  width: 7rem;
  aspect-ratio: 4/5;
`

export const SwiperDesktopNextButton = styled.button`
  display: none;

  @media screen and (min-width: 768px) {
    display: inline-flex;
    border: none;
    width: 3.2rem;
    height: 3.2rem;
    justify-content: center;
    align-items: center;
    padding: 0;
    background: transparent;
  }
`

export const VariantSelectedHighlight = styled.div`
  margin-top: 0.5rem;
  height: 0.2rem;
  max-width: 7rem;
  background: ${({ theme }) => theme.colors.text.light};
`

export const VariantsSliderWrapper = styled.div`
  max-width: 100%;
  padding: 0 0 0 1rem;

  .swiper-scrollbar {
    background: transparent;
  }

  .swiper-backface-hidden .swiper-slide {
    transform: none !important;
  }

  @media screen and (min-width: 768px) {
    width: 100%;
    padding: 0 1rem;
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 1rem;

    .swiper {
      width: 29.5rem;
      margin: 0;
    }
  }
`

export const VariantButton = styled.button`
  border: none;
  padding: 0;
  margin: 0;
  background: transparent;
`
